import React, { FC } from 'react';
import styles from './Arrow.module.scss';

const Arrow: FC<{ className: string }> = ({ className }) => {
  return (
    <svg
      className={`${styles.root} ${className}`}
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M14.0625 10.2897C14.0625 10.3882 14.035 10.4845 13.9835 10.5664C13.932 10.6482 13.8587 10.7121 13.7731 10.7497C13.6874 10.7874 13.5931 10.7972 13.5022 10.778C13.4113 10.7588 13.3278 10.7113 13.2622 10.6416L7.81567 4.85464L2.3691 10.6416C2.2807 10.7323 2.16229 10.7825 2.03938 10.7814C1.91648 10.7803 1.79891 10.7279 1.712 10.6355C1.62509 10.5432 1.57579 10.4183 1.57472 10.2877C1.57366 10.1571 1.6209 10.0313 1.70629 9.93737L7.48442 3.79811C7.57232 3.70474 7.69153 3.65229 7.81582 3.65229C7.94012 3.65229 8.05932 3.70474 8.14723 3.79811L13.9254 9.93737C13.9689 9.98364 14.0034 10.0386 14.0269 10.099C14.0505 10.1595 14.0626 10.2242 14.0625 10.2897Z" />
    </svg>
  );
};

export default Arrow;
